import { AppBar, Icon, Toolbar, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import I18n from 'i18n-js'
import { useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'

import manageBrandsPaths from '@src/components/brands/manageBrandsPaths'
import PendingInvitesChip from '@src/components/brands/PendingInvitesChip'
import retailerSettingsPaths from '@src/components/retailerSettings/retailerSettingsPaths'
import WalletButton from '@src/components/wallet/WalletButton'
import ChildSpacer from '@src/lib/ChildSpacer'
import LinkChild from '@src/lib/LinkChild'
import { useFeatureFlag } from '@src/lib/useFeatureFlag'
import { selectCurrentRetailerAccountAndBrandSlug } from '@src/stores/app/selectors'

import AccountDropdown from './AccountDropdown'
import BusinessSelectDropdown from './BusinessSelectDropdown'
import HamburgerMenu from './HamburgerMenu'
import HelpDropdown from './HelpDropDown'
import NotificationsDropdown from './NotificationsDropdown'

interface TopNavProps {
  isSidebarVisible: boolean
  showHamburger: boolean
  onClickHamburger: () => void
}

// TODO: remove this and use sx prop
const useStyles = makeStyles()((theme) => ({
  manageBrandButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}))

const TopNav: React.FC<React.PropsWithChildren<TopNavProps>> = (props) => {
  const { classes } = useStyles()
  const theme = useTheme()

  const { currentSlugs } = useSelector(selectCurrentRetailerAccountAndBrandSlug)
  const isNewSettingsEnabled = useFeatureFlag('new-business-settings')

  if (!currentSlugs.retailerAccount) {
    return null
  }

  const styles = {
    backgroundColor: theme.palette.pbxxCyan.main,
    color: theme.palette.pbxxCyan.contrastText,
  }

  const manageBrandsLink = isNewSettingsEnabled
    ? retailerSettingsPaths.brandSettings.build({
        retailerAccountSlug: currentSlugs.retailerAccount,
      })
    : manageBrandsPaths.index.build({
        retailerAccountSlug: currentSlugs.retailerAccount,
        brandSlug: currentSlugs.brand,
      })

  return (
    <>
      <AppBar position="fixed" sx={styles}>
        <Toolbar>
          {props.showHamburger && (
            <Box sx={{ flexShrink: 0 }}>
              <HamburgerMenu
                isToggled={props.isSidebarVisible}
                toggleSideNav={props.onClickHamburger}
              />
            </Box>
          )}

          <BusinessSelectDropdown />

          <div style={{ flexGrow: 1 }} />

          <LinkChild
            to={manageBrandsLink}
            // TODO: update to use sx prop
            className={classes.manageBrandButton}
            style={{
              // Intentionally inverse colors.
              color: styles.backgroundColor,
              background: styles.color,
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<Icon className="fas fa-building" />}
            >
              <ChildSpacer>
                <span>{I18n.t('manageBrands.manageBrands')}</span>
                {<PendingInvitesChip />}
              </ChildSpacer>
            </Button>
          </LinkChild>

          {<WalletButton />}

          <NotificationsDropdown />

          <AccountDropdown currentSlugs={currentSlugs} />

          <HelpDropdown />
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  )
}

export default TopNav
